// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { StudentLessonProgressionRepresentation } from './StudentLessonProgressionRepresentation'
import {
  StudentLessonProgressionRepresentationFromJSON,
  StudentLessonProgressionRepresentationFromJSONTyped,
  StudentLessonProgressionRepresentationToJSON,
} from './StudentLessonProgressionRepresentation'

/**
 *
 * @export
 * @interface StudentLessonProgressionRepresentationBaseApiResult
 */
export interface StudentLessonProgressionRepresentationBaseApiResult {
  /**
   *
   * @type {StudentLessonProgressionRepresentation}
   * @memberof StudentLessonProgressionRepresentationBaseApiResult
   */
  data?: StudentLessonProgressionRepresentation
}

/**
 * Check if a given object implements the StudentLessonProgressionRepresentationBaseApiResult interface.
 */
export function instanceOfStudentLessonProgressionRepresentationBaseApiResult(
  value: object,
): boolean {
  let isInstance = true

  return isInstance
}

export function StudentLessonProgressionRepresentationBaseApiResultFromJSON(
  json: any,
): StudentLessonProgressionRepresentationBaseApiResult {
  return StudentLessonProgressionRepresentationBaseApiResultFromJSONTyped(
    json,
    false,
  )
}

export function StudentLessonProgressionRepresentationBaseApiResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StudentLessonProgressionRepresentationBaseApiResult {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: !exists(json, 'data')
      ? undefined
      : StudentLessonProgressionRepresentationFromJSON(json['data']),
  }
}

export function StudentLessonProgressionRepresentationBaseApiResultToJSON(
  value?: StudentLessonProgressionRepresentationBaseApiResult | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data: StudentLessonProgressionRepresentationToJSON(value.data),
  }
}
